import { render, staticRenderFns } from "./SentimentCat.vue?vue&type=template&id=4fd0a92e&scoped=true"
import script from "./SentimentCat.vue?vue&type=script&lang=js"
export * from "./SentimentCat.vue?vue&type=script&lang=js"
import style0 from "./SentimentCat.vue?vue&type=style&index=0&id=4fd0a92e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd0a92e",
  null
  
)

export default component.exports